import axios from 'axios'

const axiosInstance = axios.create({
	baseURL: undefined,
	withCredentials: undefined,
})

export default axiosInstance
